import moment from "moment-timezone";

import type { GetControlHealthDashboardParams } from "api/generated/model";
import { FILTER_VALUE_DATE_FORMAT } from "components/table/FilterBarDateTimeRange/FilterBarDateTimeRangeUtils";

/** Number of days the control health dashboard shows by default, today included. */
export const DEFAULT_DUE_DATE_WINDOW_DAYS = 7;

/**
 * The default due date window of the control health dashboard: the last
 * {@link DEFAULT_DUE_DATE_WINDOW_DAYS} days up to and including today, as the
 * `YYYY-MM-DD` bounds the dashboard endpoint expects.
 */
export function buildDefaultDueDateRange(): Pick<
    GetControlHealthDashboardParams,
    "due_date_start" | "due_date_end"
> {
    const today = moment();
    return {
        due_date_start: today
            .clone()
            .subtract(DEFAULT_DUE_DATE_WINDOW_DAYS - 1, "days")
            .format(FILTER_VALUE_DATE_FORMAT),
        due_date_end: today.format(FILTER_VALUE_DATE_FORMAT),
    };
}
